import { PAGE_STATUS_MAP } from '../../../const/static.js'
export const fileSchemaHandle = {
  handle (node, { objectApiName, info: { _objectApiName, region, type }, app }) {
    node.props.data = {
      apiName: node.apiName,
      version: node.version,
      objectApiName: _objectApiName || objectApiName,
      // 接口只给页面的region，自定义对象的自定义页面 有时侯region是1，跟后端振洋沟通 接口没办法给对象region，只能先判断3和1，2022.8.03 apaas附件预览群沟通确认
      isCustom: region === 3 || region === 1,
      app,
      // 是否是新建页面标识，如果是新建页面，预览时不传bizCode
      createPageFlag: type === PAGE_STATUS_MAP.ADD || type === PAGE_STATUS_MAP.POLYMERIC_CREATE,
      // node.parentKey存在就表示当前字段在从对象
      isSubForm: !!node.parentKey
    }
  }
}

export const fileProps = {
  // 上传时附带的额外参数
  data: {
    type: Object,
    default: () => ({})
  },
  // 附件｜图片 true图片 false附件
  onlyImage: {
    type: Boolean,
    default: false
  },
  // 图片 在列表 和 从对象 的展示状态  true列表只显示一张 false从对象
  firstImgOnly: {
    type: Boolean,
    default: false
  },
  // 是否开启切片上传
  isChunk: {
    type: Boolean,
    default: true
  },
  // 是否多选
  multiple: {
    type: Boolean,
    default: true
  },
  // 组件尺寸
  size: {
    type: String,
    default: 'small'
  },
  // 文件列表
  fileList: {
    type: Array,
    default: () => []
  },
  // 上传类型
  format: {
    type: Array,
    default: () => []
  },
  // 上传文件最大体积
  maxSize: {
    type: Number,
    default: 5
  },
  // 最大上传数量
  maxUploadNum: {
    type: Number,
    default: 5
  },
  // 只读
  disabled: {
    type: Boolean,
    default: false
  },
  /*
    访问权限
    def 默认，open 公开访问，notopen 私有访问
    def 图片文件公开访问，非图片文件私有访问
  */
  permission: {
    type: String,
    default: 'def'
  },
  // 纯文本
  isPureText: {
    type: Boolean,
    default: false
  },

  // 主从
  miniMode: {
    type: Boolean,
    default: false
  },
  // 预览 附件值的key值(默认走paas接口提供的参数，如果本参数有值 优先本参数)
  previewParamKeyName: {
    type: Object,
    default: () => {
      return {
        fileReviewBusinessCode: '',
        bizCode: '',
        prewKey: '',
        name: '',
        // 下载url
        url: ''
      }
    }
  },
  filePreviewProps: {
    type: Object,
    default: () => {
      return {}
    }
  },
  // 上传组件 编辑｜详情 点击文件时的回调
  'preview': {
    type: Function
  },
  // 主｜从 当前对象的formData数据
  row: {
    type: Object,
    default: () => {
      return {}
    }
  },
  'beforeUpload': {
    type: Function
  },
  'beforeRemove': {
    type: Function
  }
}